export default __webpack_public_path__ + "static/media/ac_sh.34cdaa8a.bmp";